import { Button, Center, Image, Text, VStack } from '@chakra-ui/react';
import { useNavigate, useRouteError } from 'react-router-dom';
import backgroundLogo from 'app/assets/svg/backgroundLogo.svg';

function Error() {
  const navigate = useNavigate();
  const error = useRouteError() as { status: string };

  return (
    <Center
      bgGradient="linear(to-r, brand.darkPurple 7.24%, brand.grayishBlack 115.47%)"
      height="100vh"
    >
      <Image src={backgroundLogo} position="absolute" right={0} />

      <VStack zIndex={1} maxWidth="700px" spacing="20px">
        <Text as="h1" textStyle="h1" color="brand.white" fontSize="100px">
          {error.status || 'Oops,'}
        </Text>
        <Text as="h4" textStyle="h4SemiBold" color="brand.white" textAlign="center">
          An error ocurred while you were trying to access the page.
        </Text>
        <Text as="h4" textStyle="h4SemiBold" color="brand.white" textAlign="center">
          Please click below to go back.
        </Text>

        <Button onClick={() => navigate('/')}>Home</Button>
      </VStack>
    </Center>
  );
}

export default Error;
